import { render, staticRenderFns } from "./CarouselScrollSelect.vue?vue&type=template&id=04f8247e"
import script from "./CarouselScrollSelect.vue?vue&type=script&lang=js"
export * from "./CarouselScrollSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports